import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    level:'',
    applayoverdue:false,
  },
  mutations: {
    isprize(state,level){
      state.level = level
    },
    isapplayoverdue(state,statues){
      state.applayoverdue = statues
    }
  },
  actions: {
  },
  modules: {
  }
})
